import { LEAVE_PAYOUT_OPTIONS } from 'domain/shared/leave';
import { FieldProps, useFieldHelper, EnumField } from 'framework/ui/field';

const LeavePayoutOptionField = ({ value: inputValue, source, label }: FieldProps) => {
  const { getValue } = useFieldHelper({ value: inputValue, source });

  const value = inputValue || (getValue && getValue());

  return <EnumField label={label} value={value} options={LEAVE_PAYOUT_OPTIONS} />;
};

export default LeavePayoutOptionField;
